import { FC } from 'react'
import { FaArrowLeft, FaArrowRight } from 'react-icons/fa6'

type SwipeIndicatorProps = {
  swipeState: {
    direction: 'left' | 'right' | null
    progress: number
    isActive: boolean
    isTriggered: boolean
  }
}

export const SwipeIndicator: FC<SwipeIndicatorProps> = ({ swipeState }) => {
  const { direction, progress, isActive, isTriggered } = swipeState

  if (!isActive && !isTriggered) return null

  return (
    <div className="fixed inset-0 pointer-events-none z-50 overflow-hidden">
      <div 
        className={`absolute inset-y-0 flex items-center transition-all duration-200
          ${direction === 'left' ? 'left-0' : 'right-0'}
          ${isTriggered ? (direction === 'left' ? 'animate-shoot-left' : 'animate-shoot-right') : ''}
        `}
        style={{
          opacity: isTriggered ? 0 : progress * 0.8,
          transform: !isTriggered 
            ? `translateX(${direction === 'left' ? (progress * 30 - 30) : (30 - progress * 30)}px)`
            : undefined
        }}
      >
        <div 
          className={`
            flex items-center justify-center h-24 w-14 rounded-full backdrop-blur-md border transition-all duration-300
            ${direction === 'left' ? 'rounded-l-none' : 'rounded-r-none'}
            ${progress >= 0.8 || isTriggered
              ? 'bg-brand-secondary/40 border-brand-secondary/50 text-white shadow-[0_0_20px_rgba(var(--brand-secondary-rgb),0.3)]' 
              : 'bg-black/20 border-white/10 text-white/70'}
          `}
        >
          {direction === 'left' ? (
            <FaArrowLeft className={`transition-transform duration-300 ${progress >= 0.8 || isTriggered ? 'scale-150' : 'scale-100'}`} />
          ) : (
            <FaArrowRight className={`transition-transform duration-300 ${progress >= 0.8 || isTriggered ? 'scale-150' : 'scale-100'}`} />
          )}
        </div>
      </div>

      <style jsx global>{`
        @keyframes shoot-left {
          0% {
            transform: translateX(-30px);
            opacity: 0.8;
          }
          100% {
            transform: translateX(100vw);
            opacity: 0;
          }
        }
        @keyframes shoot-right {
          0% {
            transform: translateX(30px);
            opacity: 0.8;
          }
          100% {
            transform: translateX(-100vw);
            opacity: 0;
          }
        }
        .animate-shoot-left {
          animation: shoot-left 0.6s cubic-bezier(0.16, 1, 0.3, 1) forwards;
        }
        .animate-shoot-right {
          animation: shoot-right 0.6s cubic-bezier(0.16, 1, 0.3, 1) forwards;
        }
      `}</style>
    </div>
  )
}

export default SwipeIndicator
